import { render, staticRenderFns } from "./PamGameDragonTiger.vue?vue&type=template&id=0025d2ce&scoped=true&"
import script from "./PamGameDragonTiger.vue?vue&type=script&lang=js&"
export * from "./PamGameDragonTiger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025d2ce",
  null
  
)

export default component.exports